import React from 'react'
import AlertIcon from "~images/alert.svg";
import NotFoundIcon from "~images/not-found.svg";
import EmptyIcon from "~images/empty-icon.svg";
import {Onlinepbx, OnlinepbxButtonLink} from '@onpbx/onlinepbx-components'

export const ExpiredLink: React.FC = () => {
  return (
    <div className='onlinepbx__page__not__found'>
      <div className='onlinepbx__head'>
        <div className='onlinepbx__container'>
          <h2 className='onlinepbx__content__header__center onlinepbx__page__not__found__header'>
            <AlertIcon className='onlinepbx__page__not__found__alert' /> Срок действия ссылки истек
          </h2>
          <div className='onlinepbx__page__not__found__text'>
            Для получения новой ссылки повторите свои действия.
            <p><OnlinepbxButtonLink href='https://panel.onlinepbx.ru/login' text='Войти в личный кабинет' /></p>
          </div>
          <br/>
          <br/>
          <div className='onlinepbx__page__not__found__block'>
            <div className='onlinepbx__page__not__found__empty-content'>
              <EmptyIcon className='onlinepbx__page__not__found__icon' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExpiredLink